import { useState, useEffect, useCallback } from 'react';

const useDimScreen = () => {
  const [isDimmed, setIsDimmed] = useState(false);
  let inactivityTimer;

  const handleUserActivity = useCallback(() => {
    setIsDimmed(false);
    if (inactivityTimer) {
      clearTimeout(inactivityTimer);
    }
    inactivityTimer = setTimeout(() => {
      setIsDimmed(true);
    }, 5 * 60 * 1000); // 5 minutos
  }, []);

  useEffect(() => {
    handleUserActivity();

    window.addEventListener('mousemove', handleUserActivity);
    window.addEventListener('touchstart', handleUserActivity);
    window.addEventListener('keydown', handleUserActivity);
    window.addEventListener('scroll', handleUserActivity);

    return () => {
      if (inactivityTimer) clearTimeout(inactivityTimer);
      window.removeEventListener('mousemove', handleUserActivity);
      window.removeEventListener('touchstart', handleUserActivity);
      window.removeEventListener('keydown', handleUserActivity);
      window.removeEventListener('scroll', handleUserActivity);
    };
  }, [handleUserActivity]);

  return { isDimmed };
};

export default useDimScreen;